var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Unfortunately this site does not exist")]),_c('NiceButton',{attrs:{"title":"Go home","to":"/"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }